/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InlineEditEmiratesDocNumberDirective {
    public restrict = 'E';
    public scope;
    public template;

    public currentValue;
    public require;
    private doc_type_settings = {
        eid: {
            placeholder: '###-####-#######-#',
            errorMessage: '###-####-#######-# - Please enter a valid ID number.',
            pattern: "[0-9]{3}-[0-9]{4}-[0-9]{7}-[0-9]"
        },
        visa: {
            placeholder: '###############',
            errorMessage: 'Please enter a valid U.I.D. number (15 digits).',
            pattern: "^[0-9]{15}$"
        }
    }

    constructor(private $timeout: any) {
        this.restrict = 'E';
        this.scope = {
            value: '=',
            saveFunc: '&?',
            label: '@?',
            docType: '@?',
            canEdit: '=?',
        };
        this.require = '^^form'

        this.template = `                  
            <md-input-container class="md-block" md-is-error="form.eidField.$invalid">
                <label>{{::label}} ({{fieldPlaceholder}})</label>
                <input ng-model="value" ng-click="edit()" ng-blur="doneEdit()" ng-keyup="$event.keyCode == 13 ? doneEdit() : null" 
                        ng-disabled="canEdit == false"
                        name="eidField"
                        class="w-100"
                        ng-pattern="fieldPattern"
                        placeholder="{{fieldPlaceholder}}"
                        ng-model-options="{ allowInvalid: true }">
                <div ng-messages="form.eidField.$error">
                    <div ng-message="pattern">
                        <div class="myMessage">
                            {{fieldErrorMessage}}                 
                        </div> 
                    </div>
                </div>
            </md-input-container>
        `;
    }


    public link($scope: any, $element: any, attrs: any, formControl: any): any {
        $scope.form = formControl;

        $scope.empEdit = {
            canEdit: $scope.canEdit
        };
        if ($scope.value === '---') {
            $scope.value = "";
        }
        var inputElement: any = $($element).find(':input')[0];
        $scope.eidInput = inputElement;

        $scope.edit = function (): any {
            this.currentValue = $scope.value;
            if ($scope.value === '---') {
                $scope.value = '';
            }

            inputElement.focus();
        };

        $scope.doneEdit = function (): any {
            var newValue: any;
            newValue = $scope.value;

            var saveObj: any = {
                old: this.currentValue,
                new: newValue,
                model: attrs.value
            };
            if ($scope.saveFunc !== undefined) {
                $scope.saveFunc({args: saveObj});
            }
        };

        $scope.undo = function (): any {
            $element.removeClass('active');
            $scope.value = this.currentValue;
        };

        $scope.fieldPlaceholder = '';
        $scope.fieldErrorMessage = '';
        $scope.fieldPattern = '';
        if ($scope.docType && ($scope.docType === 'eid' || $scope.docType === 'visa' )) {
            $scope.fieldPlaceholder = this.doc_type_settings[$scope.docType].placeholder;
            $scope.fieldErrorMessage = this.doc_type_settings[$scope.docType].errorMessage;
            $scope.fieldPattern = this.doc_type_settings[$scope.docType].pattern;
        }
    }

    public static DirectiveFn($timeout: any): InlineEditEmiratesDocNumberDirective {
        return new InlineEditEmiratesDocNumberDirective($timeout);
    }
}

InlineEditEmiratesDocNumberDirective.DirectiveFn.$inject = ['$timeout'];

angular.module('beneple.global').directive('inlineEditEmiratesDocNumber', InlineEditEmiratesDocNumberDirective.DirectiveFn);





// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/inline_edit_emirates_doc_number.directive.ts